








































import {Component, Vue} from 'vue-property-decorator';
import FooterLinks from '@/components/Views/Home Page/FooterLinks.vue';
import Footer from '@/components/Views/Home Page/Footer.vue';
import ServiceListing from '@/components/Views/Home Page/ServiceListing.vue';
import CommonSidebar from '@/components/Views/UI/CommonSidebar.vue';
import PageWithSidebar from '@/components/Views/Home Page/PageWithSidebar.vue';
import HeroImage from '@/components/Views/Home Page/HeroImage.vue';
import HeaderAndCrumbs from '@/components/Views/Home Page/HeaderAndCrumbs.vue';
import {FeathersVuexFindAll} from '@/utils';
import ServicesPage from '@/components/Pages/Home Page/Services/ServicesPage.vue';

@Component({
    components: {
        ServicesPage,
        HeroImage,
    },
})
export default class Weddings extends Vue {
    public serviceQuery = null;
    public mounted() {
        this.setServiceQuery();
    }
    public async setServiceQuery() {
        const {ServiceType, Category} = this.$FeathersVuex;
        const serviceTypes = await FeathersVuexFindAll(ServiceType, {});
        const [category] = await FeathersVuexFindAll(Category, {
            query: {
                name: 'Weddings',
            },
        });
        this.serviceQuery = {
            serviceTypes: {$in: serviceTypes.map((x) => x._id)},
            category: category._id,
            $sort: {
                displayOrder: 1,
            },
        };
    }
    /*private services = [
        {
            name: 'Bridal Trial Hair & Makeup',
            priceRange: '$75.00',
            description: 'This is a consultation before your wedding day where you can create the perfect look for your special day. This service is great for wedding announcements & bridal photoshoot too.',
            imagePath: '5cf1baa0c45cc623910df251.jpg',
        },
        {
            name: 'Bride Hair',
            priceRange: '$120.00',
            description: 'From an elegant updo, old Hollywood glam curls, or sexy beach waves, whatever your desired look is, the SoPlush Beauty Pros will help perfect it.',
            imagePath: '5cf1baa0c45cc623910df25d.jpg',
        },
        {
            name: 'Bridal Airbrush with Lashes',
            priceRange: '$150.00',
            description: 'Whether the coverage is sheer or full, the mist of makeup looks perfectly natural. Minimize skin imperfections and feel like you aren\'t wearing makeup with this application. Airbrush is water and tear resistant (depending on climate can last up to 12 hours). Accentuate your eyes with lashes of your choice.',
            imagePath: '5cf168617d1aa71110a38dec.jpeg',
        },
        {
            name: 'Bride Makeup With Lashes',
            priceRange: '$120.00',
            description: 'Full makeup application with contour if desired. We use quality products that will leave you positively glowing. Add wispy eyelashes for the final touch.',
            imagePath: '5cf1baa0c45cc623910df251.jpg',
        },
        {
            name: 'Bridesmaid Hair',
            priceRange: '$60.00',
            description: 'We will create a style that will compliment the whole bridal party and use products to ensure your style lasts the whole night.',
            imagePath: '5cf1baa0c45cc623910df257.jpg',
        },
        {
            name: 'Bridesmaid Airbrush with Lashes',
            priceRange: '$150.00',
            description: 'Airbrush is more resilient and can stand sweat, tears and moisture more than traditional makeup. Add beautiful lashes to accentuate your eyes for a flawless airbrush look.',
            imagePath: '5cf1baa0c45cc623910df255.jpg',
        },
        {
            name: 'Bridesmaid Makeup with Lashes',
            priceRange: '$90.00',
            description: 'Full makeup application with contour if desired. We use quality products that will leave you positively glowing. Add wispy eyelashes for the final touch.',
            imagePath: '5cf1baa0c45cc623910df256.jpg',
        },
        {
            name: 'Flower Girl Hair or Makeup',
            priceRange: '$50.00',
            description: 'Include the little princess too with a simple makeup application or hair style.',
            imagePath: '5cf168617d1aa71110a38df0.jpeg',
        },
        {
            name: 'Groom & Groomsmen',
            priceRange: '$75.00',
            description: 'Don\'t forget the fellas!!! We will properly moisturize, correct & conceal dark circles, redness on the face and razor burn. Also spot concealing on acne and powder foundation for a more flawless look if desired.',
            imagePath: '5cf168617d1aa71110a38dfa.jpeg',
        },
    ];*/
}
